import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { HiddenText } from 'components/common/formElements';
import { getMediaUrlsInConversation } from 'extractFromState';
import {
  ImageContainer,
  ImageInfoContainer,
  ImagesGrid,
  Title,
  SubText,
  InfoContainer,
  InfoIcon,
  InfoText,
  ImageWrap,
  ImageCheckbox,
  ImageLabel,
} from './DTImageSelector.styles';
import ProtectedImage from '../../../common/ProtectedImage/ProtectedImage';

const DTImageSelector = ({ selectedImages, onSelect }) => {
  const mediaUrls = useSelector(getMediaUrlsInConversation);

  const handleImageCheckbox = (e) => {
    const url = e.target.value;

    if (selectedImages.includes(url)) {
      const filtered = selectedImages.filter((image) => image !== url);

      return onSelect(filtered);
    }

    onSelect([...selectedImages, url]);
  };

  return (
    <ImageContainer>
      <ImageInfoContainer>
        <Title>Select an image justifying replacement</Title>
        <SubText>Images in the current conversation ({mediaUrls.length})</SubText>
      </ImageInfoContainer>
      <ImagesGrid>
        {isEmpty(mediaUrls) ? (
          <InfoContainer>
            <InfoIcon src="/images/attention_icon.svg" alt="attention_icon" />
            <InfoText>
              No images in conversation <br />
              Please ask for an image of the product
            </InfoText>
          </InfoContainer>
        ) : (
          mediaUrls.map((image, index) => (
            <ImageWrap key={index}>
              <ImageCheckbox
                id={`checkbox-${index}`}
                value={image}
                onChange={handleImageCheckbox}
                checked={selectedImages.includes(image)}
              />
              <ImageLabel htmlFor={`checkbox-${index}`}>
                <HiddenText>media from customer</HiddenText>
                <ProtectedImage src={image} altText="media-from-customer" isClickable={false} />
              </ImageLabel>
            </ImageWrap>
          ))
        )}
      </ImagesGrid>
    </ImageContainer>
  );
};

export default DTImageSelector;
